import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { phoneNumberFormatter, useTranslatedText } from '@dreryk/react-common';
import { ValueRendererProps } from '@dreryk/react-components';

const PhoneCell = (
   props: ValueRendererProps<MedicalDataAccessAuthorization, PhoneNumber | undefined>
): JSX.Element | null => {
   const { phoneNumber } = props.bean;

   const formattedPatientPhone = phoneNumberFormatter(phoneNumber);
   const patientPhoneTranslatedLabel = useTranslatedText(formattedPatientPhone);

   if (!phoneNumber) {
      return null;
   }

   return <div>{patientPhoneTranslatedLabel.text}</div>;
};

export { PhoneCell };
